// Uploaded photos live on the backend (paths like /uploads/...). The console
// used to sit behind a proxy on the backend's address; now it calls the
// backend directly, so a relative photo path needs the backend's address.
const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const mediaUrl = (path) =>
  typeof path === "string" && path.startsWith("/uploads/") && backendUrl ? `${backendUrl}${path}` : path;
